import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#ethnicDisable_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Ethnic Minority And Disable Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "ethnicDisable_report",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Report Type", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-3 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_24 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#activity-report",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_25 = { class: "card-title m-0" }
const _hoisted_26 = { class: "fw-bolder m-0" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  id: "activity-report",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-9" }
const _hoisted_32 = { class: "row mb-1 w-100 m-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_34 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "table table-borderless gy-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, " Enrolled "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, " Assessed "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, " Certified "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, " Job Placed ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female ")
  ])
], -1)
const _hoisted_43 = { style: {} }
const _hoisted_44 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }
const _hoisted_45 = {
  colspan: "10",
  style: {"border":"1px solid black !important"}
}
const _hoisted_46 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_47 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_48 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_49 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_50 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_51 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_52 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_53 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_54 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_55 = { style: {"border":"1px solid black !important","text-align":"center"} }
const _hoisted_56 = {
  colspan: "2",
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_57 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_58 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_59 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_60 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_61 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_62 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_63 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_64 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_66 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_67 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_68 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_69 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_70 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_71 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_72 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }
const _hoisted_73 = { style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.associationData,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.associationData) = $event)),
                  options: _ctx.optionsTPartner,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Type",
                  modelValue: _ctx.report_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.report_type) = $event)),
                  style: {"width":"100%"},
                  onChange: _ctx.btnCheckStatus
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "ethnicsummary",
                      label: "Ethnic Minority Report"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ethnic Minority Report")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "disablesummary",
                      label: "Disable Report"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Disable Report")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.EthnicDisableSummaryReport())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_17
                ])
              ])
            ]),
            (_ctx.showEthnicDisableReport == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true),
            (_ctx.showEthnicDisableReport == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("h3", _hoisted_26, [
                            (_ctx.report_type == 'ethnicsummary')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Ethnic Minority Report"))
                              : _createCommentVNode("", true),
                            (_ctx.report_type == 'disablesummary')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Disable Report"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                  title: "Download Xlse",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                                }, _hoisted_36),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                  title: "Download PDF",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                                }, _hoisted_38),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                  title: "Print",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                                }, _hoisted_40)
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_41, [
                              _hoisted_42,
                              _createElementVNode("tbody", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.ethnicDisableReport, (info, key) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                    _createElementVNode("tr", _hoisted_44, [
                                      _createElementVNode("td", _hoisted_45, [
                                        _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                                ?.entities, (data, inx) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: inx }, [
                                        _createElementVNode("td", _hoisted_46, _toDisplayString(inx + 1), 1),
                                        _createElementVNode("td", _hoisted_47, _toDisplayString(data?.entity_short_name), 1),
                                        _createElementVNode("td", _hoisted_48, _toDisplayString(data?.enrollment), 1),
                                        _createElementVNode("td", _hoisted_49, _toDisplayString(data?.enrollment_female), 1),
                                        _createElementVNode("td", _hoisted_50, _toDisplayString(data?.assesment), 1),
                                        _createElementVNode("td", _hoisted_51, _toDisplayString(data?.assesment_female), 1),
                                        _createElementVNode("td", _hoisted_52, _toDisplayString(data?.certification), 1),
                                        _createElementVNode("td", _hoisted_53, _toDisplayString(data?.certification_female), 1),
                                        _createElementVNode("td", _hoisted_54, _toDisplayString(data?.job_placement), 1),
                                        _createElementVNode("td", _hoisted_55, _toDisplayString(data?.job_placement_female), 1)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_56, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ") ", 1),
                                      _createElementVNode("td", _hoisted_57, _toDisplayString(Number(
                                      info?.trancheInfo?.subTotalenrollment
                                    ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_58, _toDisplayString(Number(
                                        info?.trancheInfo?.subTotalenrollment_female
                                      ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_59, _toDisplayString(Number(
                                      info?.trancheInfo?.subTotalassesment
                                    ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_60, _toDisplayString(Number(
                                        info?.trancheInfo?.subTotalassesment_female
                                      ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_61, _toDisplayString(Number(
                                      info?.trancheInfo?.subTotalcertification
                                    ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_62, _toDisplayString(Number(
                                        info?.trancheInfo?.subTotalcertification_female
                                      ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(Number(
                                      info?.trancheInfo?.subtotal_job_placement
                                    ).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                                        info?.trancheInfo?.subtotal_job_placement_female
                                      ).toLocaleString()), 1)
                                    ])
                                  ], 64))
                                }), 128)),
                                _createElementVNode("tr", null, [
                                  _hoisted_65,
                                  _createElementVNode("td", _hoisted_66, _toDisplayString(Number(this.Totalenrollment).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_67, _toDisplayString(Number(this.Totalenrollment_female).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_68, _toDisplayString(Number(this.Totalassesment).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_69, _toDisplayString(Number(this.Totalassesment_female).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_70, _toDisplayString(Number(
                                    this.Totalcertification
                                  ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(Number(
                                      this.Totalcertification_female
                                    ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(Number(
                                    this.total_job_placement
                                  ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_73, _toDisplayString(Number(
                                      this.total_job_placement_female
                                    ).toLocaleString()), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}